import { Box } from "@mui/material"
import * as React from "react"
import { Draggable } from "react-beautiful-dnd"
import { permissions } from "../../../../../config/constants"
import { useSelector } from "react-redux"

export default function DraggableTab(props: any) {
  const { index, child } = props

  const allPerms = useSelector((state: any) => {
    return state.rolesAndPerms.userPerms
  })

  return (
    <Draggable
      draggableId={`${index}`}
      index={index}
      disableInteractiveElementBlocking
      isDragDisabled={
        !allPerms?.includes(permissions?.BLUEPRINT_BUCKET_MAINTENANCE)
      }
    >
      {(draggableProvided: any) => {
        return (
          <Box
            sx={{
              display: "flex",
              width: "fit-content",
              whiteSpace: "nowrap !important",
              height: "7vh",
            }}
            ref={draggableProvided.innerRef}
            {...draggableProvided.draggableProps}
            {...draggableProvided.dragHandleProps}
          >
            {React.cloneElement(child, {
              ...props,
              // ...draggableProvided.dragHandleProps,
              style: { cursor: "inherit" },
            })}
          </Box>
        )
      }}
    </Draggable>
  )
}
